import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import LAYOUT from 'constants/layout';

import styled from 'styled-components';
import COLORS from 'constants/colors';
import { Col, Row, Text } from '@cuemath/comps';
import { Separator } from '@cuemath/comps';

const CustomRow = styled(Row)`
  & > * {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: 767px) {
    display: block;
  }
`;

const GridRow = styled(Row)`
  & > :first-child {
    padding-left: 0;
  }
  & > :last-child {
    padding-right: 0;
  }
  flex-wrap: nowrap;
`;

const Label = styled.label`
  width: 50%;
  height: 45px;
`;

const FeedbackGridRow = styled(Row)`
  flex-wrap: nowrap;
  padding: 10px 20px;
`;

const ValueText = styled(Text)`
  width: 90%;
  line-height: 20px;
  color: ${COLORS.COLA};
`;

const InputCheckbox = styled.input`
  box-sizing: border-box;
  margin: 3px 3px 3px 4px;
  height: 14px;
  width: 14px;
  border: 1px solid rgba(42, 42, 46, 0.3);
  border-radius: 1px;
  background-color: ${COLORS.WHITE};
`;

export default class CheckboxInput extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string.isRequired),
    label: PropTypes.string,
    onChange: PropTypes.func,
    feedbackType: PropTypes.string,
  };

  static defaultProps = {
    label: null,
    selected: [],
    onChange: () => {},
    feedbackType: null,
  };

  onChange = e => {
    const { selected, onChange } = this.props;
    const index = selected.indexOf(e.target.value);

    if (index !== -1) {
      onChange([
        ...selected.slice(0, index),
        ...selected.slice(index + 1, selected.length),
      ]);
    } else {
      onChange([...selected, e.target.value]);
    }
  };

  getFeedbackMatrix = () => {
    const { name, options, selected } = this.props;

    return (
      <CustomRow>
        {options.map(({ id, value }) => (
          <Label htmlFor={`${name}_${id}`} key={id}>
            <FeedbackGridRow>
              <InputCheckbox
                id={`${name}_${id}`}
                name={name}
                type="checkbox"
                onChange={this.onChange}
                value={id}
                checked={selected.includes(id)}
              />
              <ValueText>{value}</ValueText>
            </FeedbackGridRow>
          </Label>
        ))}
      </CustomRow>
    );
  };

  render() {
    const { name, label, options, selected, feedbackType } = this.props;

    return (
      <Fragment>
        <Text>{label}</Text>
        {!feedbackType && <Separator height={LAYOUT.SMALL_GAP} />}
        {feedbackType === 'widget' ? (
          this.getFeedbackMatrix()
        ) : (
          <CustomRow>
            {options.map(({ id, value }) => (
              <label htmlFor={`${name}_${id}`} key={id}>
                <Col gap={LAYOUT.SMALL_GAP / 3} gutter={LAYOUT.GUTTER / 2}>
                  <GridRow>
                    <Col gutter={LAYOUT.SMALL_GAP}>
                      <input
                        id={`${name}_${id}`}
                        name={name}
                        type="checkbox"
                        onChange={this.onChange}
                        value={id}
                        checked={selected.includes(id)}
                      />
                    </Col>
                    <Col auto gutter={LAYOUT.SMALL_GAP}>
                      <Text>{value}</Text>
                    </Col>
                  </GridRow>
                </Col>
              </label>
            ))}
          </CustomRow>
        )}
      </Fragment>
    );
  }
}
